import {
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { DatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import CustomInput from "../../../../../../../Components/CustomInput";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const DueDiligenceComponent = (props) => {
  const {
    inputValue,
    handleCustomSubmit,
    rowState,
    cell,
    handleClose: handleClosePopup,
  } = props;
  console.log(
    "inputValue",
    inputValue,
    cell?.row?.original?.PartnerDueDiligenceCall_due_diligence,
    rowState
  );

  const { id, customComponentKey } = cell.column.columnDef;

  // var emptyInputValue = [
  //   {
  //     available_date: "",
  //     from: "",
  //     to: "",
  //     internal_notes: "",
  //     actions: "",
  //   },
  // ];
  // const [scheduleData, setScheduleData] = useState(emptyInputValue);
  const [dueDiligenceDetailsData, setDueDiligenceDetailsData] = useState(
    cell?.row?.original?.PartnerDueDiligenceCall_due_diligence || []
  );

  const handleDelete = (index) => {
    setDueDiligenceDetailsData((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems.splice(index, 1);
      console.log("updatedItems: " + updatedItems);
      return updatedItems;
    });
  };

  // const deleteCalls = (index) => {
  //   console.log(index);
  //   var localArr = scheduleData.filter((option, i) => i !== index);
  //   console.log("object", localArr, index);
  //   scheduleData.length = 0;
  //   setScheduleData(scheduleData.concat(localArr));
  // };

  const handleChange = (index, event) => {
    event.preventDefault();
    let data = [...dueDiligenceDetailsData];
    data[index][event.target.name] = event.target.value;
    setDueDiligenceDetailsData(data);
  };
  const handleDateChange = (index, newDate) => {
    let data = [...dueDiligenceDetailsData];
    data[index].available_date = newDate;
    setDueDiligenceDetailsData(data);
  };

  const handleTimeChange = (index, field, newTime) => {
    let data = [...dueDiligenceDetailsData];
    data[index][field] = newTime;
    setDueDiligenceDetailsData(data);
  };

  const addFields = () => {
    let newfield = {
      due_diligence_slot_id: null,
      available_date: "",
      from: "",
      to: "",
      internal_notes: "",
      actions: "",
    };
    setDueDiligenceDetailsData([...dueDiligenceDetailsData, newfield]);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const postValue = dueDiligenceDetailsData;
    console.log("scheduleData", dueDiligenceDetailsData);
    handleCustomSubmit(id, postValue, customComponentKey);
    handleClosePopup();
  };

  // const handleSubmit = () => {
  //   const postValue = scheduleData.map((el) => {
  //     const postObj = {
  //       available_date: el.available_date,
  //       from: el.from,
  //       to: el.to,
  //       internal_notes: el.internal_notes,
  //       actions: el.actions
  //     };
  //     console.log("postobj",postObj)
  //     // if (el.id) {
  //     //   postObj.id = el.id;
  //     // }
  //     // return postObj;
  //   });
  //   handleCustomSubmit(id, postValue, customComponentKey);
  //   handleClosePopup();
  // };

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        flexDirection: "column",
        alignItems: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "0.5rem",
          marginBottom: "1rem",
          width: "100%",
          height: "10%",
        }}
      >
        <Typography
          variant="h6"
          style={{ fontSize: "16px", fontWeight: "bold" }}
        >
          Due Diligence
        </Typography>

        <AddCircleIcon
          type="submit"
          onClick={() => addFields()}
          fontSize="large"
          color="primary"
          style={{ cursor: "pointer" }}
        />
      </div>
      <div
        style={{
          width: "100%",
          height: "85%",
          flexGrow: 1,
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {dueDiligenceDetailsData.length > 0 &&
          dueDiligenceDetailsData.map((option, index) => {
            return (
              <>
                <Grid
                  container
                  style={{
                    width: "100%",
                    marginBottom: "0.75rem",
                  }}
                  alignItems="flex-start"
                >
                  <Grid item container xs={10}>
                    <Grid item xs={4}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          marginBottom: "0.75rem",
                        }}
                      >
                        Due diligence date
                      </Typography>
                    </Grid>

                    <Grid item xs={8}>
                      <DatePicker
                        variant="inline"
                        value={option?.available_date || null}
                        onChange={(newDate) => handleDateChange(index, newDate)}
                        format="dd/MM/yyyy"
                        inputProps={{ style: { fontSize: "12px" } }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Select a date"
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          marginBottom: "0.75rem",
                        }}
                      >
                        Due diligence time
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={8}
                      container
                      direction="row"
                      alignItems="flex-start"
                      spacing={1}
                    >
                      <Grid item xs={6}>
                        <KeyboardTimePicker
                          value={option?.from}
                          onChange={(newTime) =>
                            handleTimeChange(index, "from", newTime)
                          }
                          inputProps={{ style: { fontSize: "12px" } }}
                          variant="inline"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <KeyboardTimePicker
                          value={option?.to}
                          onChange={(newTime) =>
                            handleTimeChange(index, "to", newTime)
                          }
                          inputProps={{ style: { fontSize: "12px" } }}
                          variant="inline"
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          marginBottom: "0.75rem",
                        }}
                      >
                        Due diligence notes
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <textarea
                        variant="outlined"
                        type="text"
                        style={{
                          width: "100%",
                          height: "30px",
                          resize: "none",
                          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                          fontSize: "12px",
                        }}
                        name="internal_notes"
                        value={option?.internal_notes}
                        onChange={(event) => handleChange(index, event)}
                        placeholder="Due diligence notes"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          marginBottom: "0.75rem",
                          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                          fontSize: "12px",
                        }}
                      >
                        Due diligence actions
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <textarea
                        variant="outlined"
                        type="text"
                        name="actions"
                        style={{
                          width: "100%",
                          height: "30px",
                          resize: "none",
                        }}
                        value={option?.actions}
                        onChange={(event) => handleChange(index, event)}
                        placeholder="Due diligence actions"
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    {dueDiligenceDetailsData.length > 1 ? (
                      <AddCircleIcon
                        type="submit"
                        onClick={() => handleDelete(index)}
                        fontSize="large"
                        color="error"
                        style={{
                          cursor: "pointer",
                          marginTop: "10px",
                          transform: "rotate(45deg)",
                        }}
                      />
                    ) : null}
                  </Grid>
                </Grid>
                <Divider style={{ marginBottom: "1rem" }} />
              </>
            );
          })}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-start",
          marginTop: "0.5rem",
          marginBottom: "1rem",
          width: "100%",
          height: "5%",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ textTransform: "none" }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default DueDiligenceComponent;
